import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OrderedSet } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Button } from '@saucelabs/sl-component-buttons';
import { Filter } from '@saucelabs/sl-component-filter';

import Styles from './GeneralFilter.styles';
import { OS_FILTERS } from '../constants';

class GeneralFilter extends Component {
  getTitle() {
    const { filter } = this.props;
    const items = filter.get('selectedItems');
    return items.size === 0 ? 'All' : `${items.size} selected`;
  }

  render() {
    const { filterKey, filter, onSelectFilter, onClick } = this.props;

    return (
      <div className={Styles['filter-wrapper']}>
        <span>OS:</span>
        <Filter
          items={new OrderedSet(OS_FILTERS)}
          onApply={(items) => onSelectFilter({ items })}
          searchable={false}
          selectedItems={filter.get('selectedItems')}
        >
          <Button
            category="link"
            onClick={() => onClick(filterKey)}
            size="sm"
          >
            {this.getTitle()}
          </Button>
        </Filter>
      </div>
    );
  }
}

GeneralFilter.propTypes = {
  filter: ImmutablePropTypes.mapContains({
    selectedItems: ImmutablePropTypes.orderedSet,
  }).isRequired,
  filterKey: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onSelectFilter: PropTypes.func.isRequired,
};

GeneralFilter.defaultProps = {
  onClick: () => { },
};

export default GeneralFilter;
